import { cloneDeep as _cloneDeep } from 'lodash'

export default { _cloneDeep }
